import { getModel, DICT_KEY } from "../utils/constants";
const MODEL_KEY = DICT_KEY.SUPPLY_USER
export function decoder(arr, key) {
    let newTit = ""
    arr.forEach(item => {
        if (item.value == key) {
            return newTit = item.label
        }
    });
    return newTit
}
export const filterTree = (treeData, id) => {
    for (let i = 0; i < treeData.length; i++) {
        if (treeData[i].key && treeData[i].key == id) {
            return treeData[i].title;
        } else if (treeData[i].children && treeData[i].children.length > 0) {
            let find = filterTree(treeData[i].children, id);
            if (find) return find
        }
    }
}
//这里过滤掉充值时，为挂账的字段
export const filterPayType = (arr, filterKey = "008011") => {
    let newArr = arr.filter(item => {
        if (item.key != filterKey) return item
    })
    return newArr
}
//这里过滤掉充值时，为挂账的字段
export const filterOnAccount = (arr, filterKey = "008011") => {
    let newArr = arr.filter(item => {
        if (item.key == filterKey) return item
    })
    return newArr
}

export const getItemResourcesHL = (path) => {
    let { userMenu } = getModel(MODEL_KEY)
    // return console.log(userMenu)
    let reducerArr = userMenu.reduce((con, next) => {
        if (next.menuUrl == path) {
            con = next.resourceDetails || [];
        }
        return con
    }, [])
    return reducerArr
}